import { Link } from "@frontend/lib/link";
import { StoreBadges } from "@frontend/components/site/store-badges";
import { CollabRoomStill } from "@frontend/components/site/stills";

const PRIMARY =
  "mkt-cta inline-flex w-full items-center justify-center rounded-full px-8 py-4 text-base font-semibold sm:w-auto";
const SECONDARY =
  "mkt-cta-ghost inline-flex w-full items-center justify-center rounded-full px-8 py-4 text-base font-semibold sm:w-auto";

const FACTS = [
  { value: "0%", label: "cut of what you're paid" },
  { value: "5", label: "timers that chase for you" },
  { value: "1", label: "link instead of a DM thread" },
  { value: "100%", label: "of changes on the record" },
];

export function Hero({ host, signedIn }: { host: string; signedIn: boolean }) {
  return (
    <section className="mkt-hero mkt-under-nav relative overflow-hidden">
      <div className="mkt-blob mkt-blob-a" aria-hidden="true" />
      <div className="mkt-blob mkt-blob-b" aria-hidden="true" />
      <div className="mkt-blob mkt-blob-c" aria-hidden="true" />
      <div className="mkt-noise" aria-hidden="true" />

      <div className="relative mx-auto w-full max-w-6xl px-4 pt-28 pb-16 sm:pt-32 sm:pb-20 lg:pt-36 lg:pb-24">
        <div className="grid items-center gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,23rem)] lg:gap-16">
          <div className="min-w-0">
            <p className="mkt-in mkt-d1 mkt-kicker">Collaborations, closed clean</p>

            <h1 className="mkt-in mkt-d2 mkt-display mt-5 max-w-[16ch] text-[2.6rem] leading-[1.03] text-balance text-ink sm:text-[3.4rem] lg:text-[4.1rem]">
              Turn brand DMs into deals that{" "}
              <span className="mkt-serif text-[#0a9f56]">actually pay</span>
            </h1>

            <p className="mkt-in mkt-d3 mt-6 max-w-md text-lg leading-relaxed text-ink/60 sm:text-xl">
              One link for inbound offers. Counter until the terms fit, freeze them into a
              contract, and get paid by stage — with a clock on every step.
            </p>

            <div className="mkt-in mkt-d4 mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              {signedIn ? (
                <Link href="/collabs" className={PRIMARY}>
                  Open your collabs
                </Link>
              ) : (
                <>
                  <Link href="/login" className={PRIMARY}>
                    Create your collab link
                  </Link>
                  <Link href="/how-it-works" className={SECONDARY}>
                    See how it works
                  </Link>
                </>
              )}
            </div>

            <div className="mkt-in mkt-d5 mt-8">
              <StoreBadges />
            </div>
          </div>

          <div className="mkt-in mkt-d3 w-full min-w-0 justify-self-center lg:justify-self-end">
            <div className="mkt-hero-still">
              <CollabRoomStill host={host} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FactStrip() {
  return (
    <section className="bg-[#f3f7f4]">
      <dl className="mx-auto grid w-full max-w-6xl grid-cols-2 gap-x-4 gap-y-8 px-4 py-14 lg:grid-cols-4 lg:py-16">
        {FACTS.map((fact, index) => (
          <div key={fact.label} className="mkt-fact" style={{ animationDelay: `${index * 80}ms` }}>
            <dt className="mkt-display tabular text-4xl text-ink sm:text-5xl">
              {fact.value}
            </dt>
            <dd className="mt-2 max-w-[12rem] text-sm leading-snug text-ink/55">{fact.label}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
